
import { Vue } from 'vue-class-component'

export default class AppLoader extends Vue {}
